import OnboardingSlide from './OnboardingSlide';
import WelcomeDemoAnimation from './WelcomeDemoAnimation';

export default function SlideWelcome() {
  return (
    <OnboardingSlide illustration={<WelcomeDemoAnimation />} title="Welcome to Sawtna">
      <p className="text-center text-base text-gray-500">
        Voice AI clinical documentation for hospital nurses in Jordan.
      </p>
      <p>
        Sawtna turns what you say into structured clinical notes — progress notes, vitals, medication
        records, and shift handovers — in seconds.
      </p>
      <p>
        This short tutorial walks through the app step by step. It takes about two minutes.
      </p>
    </OnboardingSlide>
  );
}
